const RECIPIENT_TYPES = new Set(["artist", "venue", "studio", "media"]);

function collectionFrom(payload, keys) {
  if (Array.isArray(payload)) return payload;
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
    if (payload?.[key] && typeof payload[key] === "object") return [payload[key]];
  }
  return [];
}

export function normalizeThreads(payload) {
  return collectionFrom(payload, ["threads", "items", "data"]).filter((thread) => (
    thread && thread.id != null && String(thread.id).trim()
  ));
}

export function normalizeMessages(payload) {
  return collectionFrom(payload, ["messages", "message", "items", "data"]).filter((message) => (
    message
    && message.id != null
    && typeof message.body === "string"
    && message.body.trim()
  ));
}

export function recipientCannotReply(thread) {
  return thread?.recipientCanReply === false;
}

export function isPendingEventInvitation(message) {
  return message?.kind === "EVENT_INVITATION"
    && message?.invitationStatus === "INVITED"
    && typeof message?.invitationId === "string"
    && Boolean(message.invitationId.trim());
}

export function buildRecipientInboxPath(recipientType, recipientId) {
  if (!RECIPIENT_TYPES.has(recipientType) || recipientId == null || String(recipientId).trim() === "") {
    throw new Error("A valid chat recipient is required.");
  }
  const query = new URLSearchParams({
    recipientType,
    recipientId: String(recipientId),
  });
  return `/inbox?${query.toString()}`;
}
